import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter} from 'react-router-dom';
import { suppressConsoleInProduction } from './utils/consoleSuppress';
import { initializeErrorSuppression } from './utils/networkErrorSuppressor';

// Suppress all console output in production IMMEDIATELY
suppressConsoleInProduction();

// Suppress network errors in production IMMEDIATELY
initializeErrorSuppression();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
    <App />
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

